var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "" + _vm.baseClass }, [
    _c(
      "button",
      {
        class: _vm.baseClass + "-minus",
        attrs: { disabled: _vm.locked },
        on: {
          click: function ($event) {
            return _vm.$emit("sub")
          },
        },
      },
      [_c("SVGMinus")],
      1
    ),
    _vm._v(" "),
    _c("span", {
      class: _vm.baseClass + "-value",
      domProps: { innerHTML: _vm._s(_vm.quantity) },
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        class: _vm.baseClass + "-plus",
        attrs: { disabled: _vm.locked },
        on: {
          click: function ($event) {
            return _vm.$emit("add")
          },
        },
      },
      [_c("SVGPlus")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }